import styled from 'styled-components';
import React from 'react';

const Container = styled.div`
  margin-top: 10px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 3px;
`;

class FormItem extends React.PureComponent {
  render() {
    return (
      <Container {...this.props.containerProps}>
        {this.props.label && <Label>{this.props.label}:</Label>}
        {this.props.children}
      </Container>
    );
  }
}

FormItem.defaultProps = {
  label: null,
  containerProps: {},
};

export default FormItem;



// WEBPACK FOOTER //
// ./src/components/common/FormItem/index.js